import Entity from "./entities/Entity";
import EventEntity from "./entities/EventEntity";
import common from "../common";
import Manager from "./Manager";
import DoorSurprise from "./entities/DoorSurprise";
import ChestSurprise from "./entities/ChestSurprise";
import KnightSurprise from "./entities/KnightSurprise";
import TypePool from "./TypePool";

export default class EntityManager extends Manager {

    static create(type) {
        let entity;

        switch (type) {
            default:
            case EntityManager.TYPE.CHAIR : {
                entity = new Entity(new PIXI.Point(0, 1), P3.assets.texture("chair"));
                entity.position.set(0, -common.STAGE_HEIGHT * 0.2);
                break;
            }
            case EntityManager.TYPE.CHEST: {
                entity = new ChestSurprise(new PIXI.Point(0, 1), P3.assets.texture("chest_closed"));
                entity.position.set(0, -common.STAGE_HEIGHT * 0.2);
                break;
            }
            case EntityManager.TYPE.DOOR: {
                entity = new DoorSurprise(new PIXI.Point(), P3.assets.texture("door_back_1"))
                entity.position.set(0, -common.STAGE_HEIGHT);
                break;
            }
            case EntityManager.TYPE.DRAPES: {
                entity = new Entity(new PIXI.Point(), P3.assets.texture(P3.utils.selectRandom(["drapes", "drapes1"])));
                entity.position.set(0, -common.STAGE_HEIGHT);
                break;
            }
            case EntityManager.TYPE.PAINTINGS: {
                entity = new Entity(new PIXI.Point(), P3.assets.texture("paintings"));
                entity.position.set(0, -common.STAGE_HEIGHT * 0.95 - P3.math.randomInt(0, 20));
                break;
            }
            case EntityManager.TYPE.PORTRAIT_A: {
                entity = new EventEntity(new PIXI.Point(0), P3.assets.texture("portrait_eyes_l"), P3.assets.texture("portrait_eyes_d"), P3.assets.texture("portrait_eyes_r"));
                entity.position.set(0, -common.STAGE_HEIGHT * 0.85 - P3.math.randomInt(0, 60));
                break;
            }
            case EntityManager.TYPE.PORTRAIT_B: {
                entity = new EventEntity(new PIXI.Point(), P3.assets.texture("portrait1_eyes_l"), P3.assets.texture("portrait1_eyes_d"), P3.assets.texture("portrait1_eyes_r"));
                entity.position.set(0, -common.STAGE_HEIGHT * 0.85 - P3.math.randomInt(0, 60));
                break;
            }
            case EntityManager.TYPE.PORTRAIT_C: {
                entity = new EventEntity(new PIXI.Point(), P3.assets.texture("portrait2_eyes_l"), P3.assets.texture("portrait2_eyes_d"), P3.assets.texture("portrait2_eyes_r"));
                entity.position.set(0, -common.STAGE_HEIGHT * 0.95 - P3.math.randomInt(0, 60));
                break;
            }
            case EntityManager.TYPE.PORTRAIT_D: {
                entity = new EventEntity(new PIXI.Point(), P3.assets.texture("portrait3_eyes_l"), P3.assets.texture("portrait3_eyes_d"), P3.assets.texture("portrait3_eyes_r"));
                entity.position.set(0, -common.STAGE_HEIGHT * 0.85 - P3.math.randomInt(0, 60));
                break;
            }
            case EntityManager.TYPE.SOFA: {
                entity = new Entity(new PIXI.Point(0, 1), P3.assets.texture("sofa"));
                entity.position.set(0, -common.STAGE_HEIGHT * 0.2);
                break;
            }
            case EntityManager.TYPE.WALL_WEAPONS: {
                entity = new Entity(new PIXI.Point(0, 1), P3.assets.texture("swords_shield"));
                entity.position.set(0, -common.STAGE_HEIGHT * 0.5 + 20);
                break;
            }
            case EntityManager.TYPE.WINDOW: {
                entity = new Entity(new PIXI.Point(0, 1), P3.assets.texture("window"));
                entity.position.set(0, -common.STAGE_HEIGHT * 0.5);
                break;
            }
            case EntityManager.TYPE.TRASH: {
                entity = new Entity(new PIXI.Point(0, 0), P3.assets.texture("trash"));
                entity.position.set(0, -common.STAGE_HEIGHT);
                break;
            }
            case EntityManager.TYPE.TRASH2: {
                entity = new Entity(new PIXI.Point(0, 0), P3.assets.texture("trash1"));
                entity.position.set(0, -common.STAGE_HEIGHT);
                break;
            }
            case EntityManager.TYPE.KNIGHT_COLUMN: {
                entity = new Entity(new PIXI.Point(0, 0), P3.assets.texture("knight_columns"));
                entity.position.set(0, -common.STAGE_HEIGHT);
                break;
            }
            case EntityManager.TYPE.STAIRS: {
                entity = new Entity(new PIXI.Point(0, 0), P3.assets.texture("stairs"));
                entity.position.set(0, -common.STAGE_HEIGHT);
                break;
            }
            case EntityManager.TYPE.COLUMN: {
                entity = new Entity(new PIXI.Point(0, 0), P3.assets.texture("column"));
                entity.position.set(0, -common.STAGE_HEIGHT);
                break;
            }
            case EntityManager.TYPE.LIGHT: {
                entity = new Entity(new PIXI.Point(0, 0), P3.assets.texture("light"));
                entity.position.set(0, -common.STAGE_HEIGHT + 30);
                break;
            }
            case EntityManager.TYPE.KNIGHT_SURPRISE: {
                entity = new KnightSurprise(new PIXI.Point(0, 0), P3.assets.texture("knight_with_axe"));
                entity.position.set(0, -common.STAGE_HEIGHT + 30);
                break;
            }
        }

        return entity;
    }

    constructor(entityContainer) {
        super(entityContainer);
        this._types = [];

        for (let key in EntityManager.TYPE) {
            if (EntityManager.TYPE.hasOwnProperty(key)) {
                this._types.push(EntityManager.TYPE[key]);
            }
        }

        this._typePool = new TypePool(this._types);

        this._spacingMin = 90;
        this._spacingMax = 400;

        this._nextEntityX = common.STAGE_WIDTH * 0.5; // start on a blank corridor with no entities

        this._firstPop = true;
    }

    populate(length) {
        for (let i = 0; i < length; i++) {
            let type;

            if (!this._firstPop) {
                type = this._typePool.draw();
            } else {
                if (i === 0) {
                    type = EntityManager.TYPE.PORTRAIT_B;
                } else if (i === 1) {
                    type = EntityManager.TYPE.KNIGHT_COLUMN;
                } else {
                    type = this._typePool.draw();
                }
            }

            const entity = EntityManager.create(type);
            entity.x = this._nextEntityX;

            this._container.addChild(entity);

            this._nextEntityX = entity.x + entity.width + P3.math.randomInt(this._spacingMin, this._spacingMax);

            if (this._nextEntityX >= this.worldLength) {
                this._stopped = true;
                break;
            }
        }

        if (this._firstPop)
            this._firstPop = false;
    }

    update(eventTarget, dt) {
        if (this._stopped)
            return;

        for (let i = this._container.children.length - 1; i >= 0; i--) {
            const entity = this._container.children[i];

            if (entity.transform)
                entity.update(dt);

            const global = entity.getGlobalPosition();

            if (global.x <= eventTarget) {
                entity.activate();
            }
            if (global.x <= eventTarget - 680) {
                entity.deactivate();
            }
            if (global.x <= -entity.width) {
                entity.destroy();
            }
        }

        // if last entity is on screen, make some new ones
        if (!this._container.children.length || this._container.children[this._container.children.length - 1].getGlobalPosition().x <= common.STAGE_WIDTH) {
            this.populate(6);
        }

    }

}

EntityManager.TYPE = {};
EntityManager.TYPE.CHAIR = "chair";
EntityManager.TYPE.CHEST = "chest";
EntityManager.TYPE.DOOR = "door";
EntityManager.TYPE.DRAPES = "drapes";
EntityManager.TYPE.PAINTINGS = "paintings";
EntityManager.TYPE.PORTRAIT_A = "portrait1";
EntityManager.TYPE.PORTRAIT_B = "portrait2";
EntityManager.TYPE.PORTRAIT_C = "portrait3";
EntityManager.TYPE.PORTRAIT_D = "portrait4";
EntityManager.TYPE.SOFA = "sofa";
EntityManager.TYPE.WALL_WEAPONS = "weapons";
EntityManager.TYPE.WINDOW = "window";
EntityManager.TYPE.TRASH = "trash";
EntityManager.TYPE.TRASH2 = "trash2";
EntityManager.TYPE.STAIRS = "stairs";
EntityManager.TYPE.COLUMN = "column";
EntityManager.TYPE.LIGHT = "light";
EntityManager.TYPE.KNIGHT_COLUMN = "knight_column";
EntityManager.TYPE.KNIGHT_SURPRISE = "knight_surprise";